/**
 * Platform Services — Barrel Export
 * Initialize all platform adapters at app startup
 */

export { detectPlatform, isElectron, isCapacitor, isPWA, isMacOS, isWindows, getPlatformName } from './platform';
export type { Platform } from './platform';

export { createStorageAdapter, getStorageAdapter } from './storage.adapter';
export type { StorageAdapter } from './storage.adapter';

export { createNotificationAdapter, getNotificationAdapter } from './notification.adapter';
export type { NotificationAdapter } from './notification.adapter';

export { createUpdateAdapter, getUpdateAdapter } from './update.adapter';
export type { UpdateAdapter, UpdateInfo, UpdateCallback } from './update.adapter';

import { detectPlatform } from './platform';
import { createStorageAdapter } from './storage.adapter';
import { createNotificationAdapter } from './notification.adapter';
import { createUpdateAdapter } from './update.adapter';

/**
 * Initialize all platform adapters. Call once at app startup (before store hydration).
 */
export function initializePlatform() {
  const platform = detectPlatform();
  createStorageAdapter(platform);
  createNotificationAdapter(platform);
  createUpdateAdapter(platform);
  return platform;
}
